const buildPlayerStatsDuel = (desiredStats, statsMap, stats, dictMap, isPitcher) => {
    let beforeText = '';
    const beforeList = [];
    const afterList = [];
    const bottomList = [];
    let count = 0;
    const {
        before = [],
        after = [],
        bottom = [],
        beforeSeparator = ' - ',
        afterSeparator = ', '
    } = desiredStats;

    before.forEach((stat) => {
        const temp = (statsMap && statsMap[stat]) ? statsMap[stat]({ stats, dictMap }) : '';
        if (typeof temp !== 'undefined' && temp !== 'undefined') {
            if (isPitcher) {
                beforeList.push(temp);
            } else {
                beforeText = beforeText + temp;
            }
        }
    });

    after.forEach((stat) => {
        const temp = (statsMap && statsMap[stat]) ? statsMap[stat]({ stats, dictMap }) : '';
        if (isPitcher) {
            if (typeof temp !== 'undefined' && temp !== 'undefined') {
                afterList.push(temp);
            }
        } else {
            if (temp && count < 3) {
                afterList.push(temp);
                count++;
            }
        }
    });

    bottom.forEach((stat) => {
        const temp = (statsMap && statsMap[stat]) ? statsMap[stat]({ stats, dictMap }) : '';
        if (typeof temp !== 'undefined' && temp !== 'undefined') {
            bottomList.push(temp);
        }
    });

    return {
        afterList,
        beforeText,
        beforeList,
        bottomList,
        beforeSeparator,
        afterSeparator
    };
};

export default buildPlayerStatsDuel;
